import React, { useState } from 'react';
import Select from 'src/components/common/Select';
import { SelectValue } from 'antd/lib/select';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';

const { RangePicker } = DatePicker;
const { Option } = Select;

type ShallowDateFilterProps = {
  setParams: (name: string, value: any) => void;
  categoryOptions: any[];
};

const ShallowDateFilter: React.FC<ShallowDateFilterProps> = ({ setParams, categoryOptions }) => {
  const [selectedOption, setSelectedOption] = useState<string | undefined>(undefined);
  const [dateRange, setDateRange] = useState<any>(null);

  const onOptionChange = (value: SelectValue | null) => {
    const newValue: string | undefined = value ? value.toString() : undefined;

    // Set the selected option and clear the date range
    setParams('optionSelect', newValue);
    setSelectedOption(newValue);

    // Clear date range when option is selected
    setDateRange(null);
    setParams('date', null); // Clear the date range in the parent
  };

  const onDateRangeChange = (dates: any, range: any) => {
    const newDate = range[0]
      ? {
          startDate: range[0],
          endDate: range[1],
        }
      : null;

    // Set the date range and clear the selected option
    setParams('date', newDate);
    setDateRange(dates);

    setSelectedOption(undefined);
    setParams('optionSelect', undefined); // Clear the selected option in the parent
  };

  const disabledDate = (current: Moment | null) => {
    const endOfCurrentMonth = moment().endOf('day');
    return current ? current > endOfCurrentMonth : false;
  };

  return (
    <>
      <Select
        placeholder="Select Option"
        onChange={onOptionChange}
        allowClear
        value={selectedOption || undefined}
      >
        {categoryOptions.map((option: any, i: number): React.ReactNode => (
          <Option value={option.id} key={`date-${option.name}-${i}`} title={option.name}>
            {option.name}
          </Option>
        ))}
      </Select>
      <span style={{ padding: '0 17px', lineHeight: '40px' }}>OR</span>
      <RangePicker
        allowClear
        format={'YYYY-MM-DD'}
        onChange={onDateRangeChange}
        value={dateRange}
        disabledDate={disabledDate}
        placeholder={['Start Date', 'End Date']}
        defaultPickerValue={[moment().subtract(1, 'months').startOf('month'), moment()]}
      />
    </>
  );
};

export default ShallowDateFilter;
